<template>
  <div class="min-h-full flex bg-main-layout">
    <Sidebar class="xs:hidden md:block"></Sidebar>
    <div class="w-full h-full flex flex-col items-center mt-0">
      <Header></Header>
      <div
        class="w-full px-4 md:px-8 transition-padding"
        :class="{
          'md:pl-222px': !sidebarMini,
          'md:pl-92px': sidebarMini,
          'mt-76px': showHeader,
        }"
      >
        <router-view></router-view>
      </div>
    </div>
    <MobileMenu class="flex md:hidden"></MobileMenu>
  </div>
</template>

<script>
import Header from '@/views/Header.vue';
import Sidebar from '@/views/Sidebar.vue';
import MobileMenu from '@/views/MobileMenu.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'MainLayout',
  components: { Sidebar, Header, MobileMenu },
  computed: {
    ...mapGetters({
      showHeader: 'showHeader',
      sidebarMini: 'sidebarMini',
    }),
  },
};
</script>

<style></style>
